import React from 'react';
import PropTypes from 'prop-types';

import SwitchToggle from './SwitchToggle';

const RoleToggle = ({
  tabIndex = 0,
  onChangeRoles,
  role,
  stakeholderRoles,
  isDisabled = false,
}) => {
  return (
    <SwitchToggle
      tabIndex={tabIndex}
      checked={stakeholderRoles.includes(role)}
      onChange={val => onChangeRoles(role, val)}
      disabled={isDisabled}
      messagePath={`products-fe.components.stakeholders.form.role_question.${role}`}
    />
  );
};

RoleToggle.propTypes = {
  role: PropTypes.string.isRequired,
  stakeholderRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChangeRoles: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  tabIndex: PropTypes.number,
};

export default RoleToggle;
